import { render, staticRenderFns } from "./hubsTable.vue?vue&type=template&id=51c53a4a&scoped=true&"
import script from "./hubsTable.vue?vue&type=script&lang=js&"
export * from "./hubsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c53a4a",
  null
  
)

export default component.exports